import * as tslib_1 from "tslib";
import { DatePipe } from '@angular/common';
import { PipeTransform } from '@angular/core';
import { ConfigService } from '../services/config/config.service';
var DateFromConfigPipe = /** @class */ (function (_super) {
    tslib_1.__extends(DateFromConfigPipe, _super);
    function DateFromConfigPipe(locale, configService) {
        var _this = _super.call(this, locale) || this;
        _this.configService = configService;
        return _this;
    }
    DateFromConfigPipe.prototype.transform = function (value, property, timezone, locale) {
        var format = this.configService.config[property];
        if (format === undefined) {
            throw new Error("Property \"" + property + "\" is not defined in config.json, RawConfig or Config!");
        }
        return _super.prototype.transform.call(this, value, format, timezone, locale);
    };
    return DateFromConfigPipe;
}(DatePipe));
export { DateFromConfigPipe };
